// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__AJ2Kd","col":"styles_col__11b0i"};